import React from 'react';
import {useStyles} from "./ShowArticleStatus.style";
import {useI18nContext} from "../../../contexts/I18nContext";
import clsx from "clsx";
import ArticleStatus from "../../../entities/ArticleStatus";
import ShowArticleStatusProperties from './ShowArticleStatusProperties';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import LockIcon from '@mui/icons-material/Lock';
import DeleteIcon from '@mui/icons-material/Delete';

const ShowArticleStatus: React.FC<ShowArticleStatusProperties> = ({
                                                                        status,
                                                                        className = '',
                                                                    }) => {
    const i18n = useI18nContext();
    const classes = useStyles();

    if (!status) {
        return <></>;
    }

    const getIcon = () => {
        switch (status) {
            case ArticleStatus.FOR_SALE:
                return <CheckCircleIcon className={classes.icon}/>;
            case ArticleStatus.INACTIVE:
                return <CancelIcon className={classes.icon}/>;
            case ArticleStatus.INTERNAL:
                return <LockIcon className={classes.icon}/>;
            case ArticleStatus.REMOVED:
                return <DeleteIcon className={classes.icon}/>;
        }
    }

    const getText = () => {
        switch (status) {
            case ArticleStatus.FOR_SALE:
                return i18n.translate("ACTIVE");
            case ArticleStatus.INACTIVE:
                return i18n.translate("INACTIVE");
            case ArticleStatus.INTERNAL:
                return 'Interno';
            case ArticleStatus.REMOVED:
                return i18n.translate("REMOVED");
        }
    }

    const getClass = () => {
        switch (status) {
            case ArticleStatus.FOR_SALE:
                return classes.active;
            case ArticleStatus.INACTIVE:
                return classes.inactive;
            case ArticleStatus.INTERNAL:
                return classes.internal;
            case ArticleStatus.REMOVED:
                return classes.removed;
        }
    }

    return (
        <div className={clsx(classes.status_label, getClass(), className)}>
            {getIcon()}
            <span>{getText()}</span>
        </div>
    )
}

export default ShowArticleStatus;
